exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/** GFT SuperWin Bold **/\n\n@font-face {\n    font-family: 'gft_superwin_bold';\n    src: url(" + require("./GFTSuperWin-Bold.ttf") + ") format('truetype');\n    font-weight: normal;\n    font-style: normal;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /builds/applied-technologies/apt-lab/digitalbank-frontend-projects/digitalbank-web/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!/builds/applied-technologies/apt-lab/digitalbank-frontend-projects/digitalbank-web/node_modules/postcss-loader?{"ident":"postcss"}!/builds/applied-technologies/apt-lab/digitalbank-frontend-projects/digitalbank-web/src/styles/fonts/GFTSuperWin-Bold/fonts.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/styles/fonts/GFTSuperWin-Bold/fonts.css
// module chunks = main styles